"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { usePlatformAuthOptional } from "@/context/PlatformAuthContext";
import type { PlatformUser } from "@/context/PlatformAuthContext";

/**
 * Redirects to /home if the user doesn't have the given module enabled.
 * Returns { ready } — render nothing until auth is loaded.
 */
export function useRequireModule(module: keyof PlatformUser): { ready: boolean } {
  const auth = usePlatformAuthOptional();
  const router = useRouter();

  const loading = auth?.loading ?? true;
  const user = auth?.user ?? null;
  const allowed = !user || user[module] !== false;

  useEffect(() => {
    if (!loading && user && user[module] === false) {
      router.replace("/home");
    }
  }, [loading, user, module, router]);

  return { ready: !loading && !!user && allowed };
}
